module.exports = __webpack_public_path__ + "static/media/service-6_old.8bc9f543.jpg";